export * from '@primeuix/themes/lara/password';
export { default } from '@primeuix/themes/lara/password';
